import { useState } from "react";
import { Loader2, ShieldCheck, Star, Trash2 } from "lucide-react";

export default function BulkToolbar({ count, busy, onClear, onAction }) {
  const [category, setCategory] = useState("");
  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-white rounded-2xl shadow-2xl border border-orange-200 px-4 py-3 flex items-center gap-3 flex-wrap max-w-[95vw]"
      data-testid="bulk-toolbar"
    >
      <span className="font-bold text-sm whitespace-nowrap">
        <b className="text-orange-600">{count}</b> selectionnee{count > 1 ? "s" : ""}
      </span>
      <button
        type="button"
        onClick={() => onAction("patch", { premium: true })}
        disabled={busy}
        className="px-3 py-1.5 rounded-full text-xs font-semibold bg-orange-100 text-orange-700 hover:bg-orange-200 disabled:opacity-50 inline-flex items-center gap-1"
        data-testid="bulk-mark-premium"
      >
        <Star size={12} /> Premium
      </button>
      <button
        type="button"
        onClick={() => onAction("patch", { premium: false })}
        disabled={busy}
        className="px-3 py-1.5 rounded-full text-xs font-semibold bg-orange-50 text-orange-700 border border-orange-200 hover:bg-orange-100 disabled:opacity-50"
        data-testid="bulk-unmark-premium"
      >
        Retirer Premium
      </button>
      <button
        type="button"
        onClick={() => onAction("patch", { verified: true })}
        disabled={busy}
        className="px-3 py-1.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 hover:bg-green-200 disabled:opacity-50 inline-flex items-center gap-1"
        data-testid="bulk-mark-verified"
      >
        <ShieldCheck size={12} /> Verifie
      </button>
      <button
        type="button"
        onClick={() => onAction("patch", { verified: false })}
        disabled={busy}
        className="px-3 py-1.5 rounded-full text-xs font-semibold bg-green-50 text-green-700 border border-green-200 hover:bg-green-100 disabled:opacity-50"
        data-testid="bulk-unmark-verified"
      >
        Retirer Verifie
      </button>
      <div className="flex items-center gap-1 border-l border-[var(--line)] pl-3">
        <input
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          placeholder="Nouvelle categorie"
          className="px-2 py-1 rounded-lg border border-[var(--line)] text-xs w-40"
          data-testid="bulk-category-input"
        />
        <button
          type="button"
          onClick={() => { if (category.trim()) { onAction("patch", { category: category.trim() }); setCategory(""); } }}
          disabled={busy || !category.trim()}
          className="px-3 py-1.5 rounded-full text-xs font-semibold bg-[var(--ink)] text-white hover:opacity-90 disabled:opacity-50"
          data-testid="bulk-apply-category"
        >
          Appliquer
        </button>
      </div>
      <button
        type="button"
        onClick={() => onAction("delete")}
        disabled={busy}
        className="px-3 py-1.5 rounded-full text-xs font-semibold bg-red-50 text-red-600 border border-red-200 hover:bg-red-100 disabled:opacity-50 inline-flex items-center gap-1"
        data-testid="bulk-delete"
      >
        <Trash2 size={12} /> Supprimer
      </button>
      <button
        type="button"
        onClick={onClear}
        disabled={busy}
        className="px-3 py-1.5 rounded-full text-xs font-semibold text-[var(--ink-soft)] hover:bg-orange-50"
        data-testid="bulk-clear"
      >
        Annuler
      </button>
      {busy && <Loader2 size={14} className="animate-spin text-orange-500" />}
    </div>
  );
}
